import type { OrderStatus } from './order.types';

/** 라벨 없음 스타일일 때 사용하는 뱃지 (라벨/뱃지 정책 통일) */
export const ORDER_MAP_MARKER_NO_LABEL_BADGE = '-' as const;

/**
 * 주문 상세 지도 마커의 라벨/뱃지 표시 정책
 *
 * - 라벨 없음: appointment 미존재 또는 취소 → 뱃지 '-', 라벨 ''
 * - 라벨 있음: appointment 존재 + 미취소 → 뱃지 = 해당일 해당 플래너 상담 순서, 라벨 = 상담원명
 *
 * @param hasAppointment 배정된 visit counsel 존재 여부
 * @param orderStatus 주문 상태
 * @returns true면 no-label 스타일 (뱃지 '-', 라벨 '')
 */
export function shouldUseOrderMapMarkerNoLabelStyle(
  hasAppointment: boolean,
  orderStatus?: OrderStatus['type']
): boolean {
  const isCancelled = orderStatus === 'ClosedLost' || orderStatus === 'Unqualified';
  return !hasAppointment || isCancelled;
}
